// Phone validation — Phase 1 (format only). OTP verification is planned for Phase 2.
//
// Mirrors the backend helper _validate_phone() in backend/server.py: normalize by
// stripping spaces, dashes, parentheses and plus signs; accept a US 10-digit
// number or +1 followed by 10 digits; reject fakes/placeholders (repeated digits,
// obvious sequences, letters/invalid characters, wrong length, and NANP area or
// exchange codes that start with 0 or 1). Keep both implementations in sync.

const PHONE_STRIP_RE = /[\s\-()+]/g;
const PHONE_SEQUENCES = new Set(['1234567890', '0123456789', '9876543210', '0987654321']);

// User-facing message shown for any invalid phone number.
export const PHONE_ERROR = 'Please enter a valid phone number.';

// Remove spaces, dashes, parentheses and plus signs.
export const normalizePhone = (v) => String(v == null ? '' : v).replace(PHONE_STRIP_RE, '');

// True when `v` is a valid US-style phone number per the rules above.
export const isValidPhone = (v) => {
  const norm = normalizePhone(v);
  if (!/^[0-9]+$/.test(norm)) return false;            // letters / invalid characters
  let core;
  if (norm.length === 11 && norm[0] === '1') core = norm.slice(1);
  else if (norm.length === 10) core = norm;
  else return false;                                   // too short / too long / 11 not +1
  if (new Set(core).size === 1) return false;          // repeated same digit
  if (PHONE_SEQUENCES.has(core)) return false;         // obvious sequences
  let asc = true, desc = true;
  for (let i = 0; i < 9; i++) {
    if (Number(core[i + 1]) - Number(core[i]) !== 1) asc = false;
    if (Number(core[i]) - Number(core[i + 1]) !== 1) desc = false;
  }
  if (asc || desc) return false;                       // generic consecutive run
  if ('01'.includes(core[0]) || '01'.includes(core[3])) return false; // NANP area/exchange
  return true;
};
